// src/components/common/CheckInHistory.js
import React, { useState } from 'react';
import { ChevronLeft, CheckCircle } from 'lucide-react';
import { useRequestProcessor } from '../../requestProcessor';
import { useAtom } from 'jotai';
import { activeChildDetail } from '../../atomstore/store';
import { getAttendance } from '../../queryfunctions/queryfunctions';
import SpinnerLoading from './SpinnerLoading';
import { useNavigate } from 'react-router-dom';

const CheckInHistory = () => {
    const { useQueryWrapper } = useRequestProcessor();
    const [activeChild] = useAtom(activeChildDetail);
    const [currentDate] = useState({
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
    });
    const navigate = useNavigate()
    const {
        data: attendanceList = [],
        isLoading,
        isFetching,
    } = useQueryWrapper(
        [
            "getAttendance",
            "attendance" + activeChild?.id,
            currentDate.year,
            currentDate.month,
        ],
        () => getAttendance()
    );

    console.log("Attendance List", attendanceList);

    if (isLoading || isFetching) {
        return <SpinnerLoading />;
    }

    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto">
            <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={() => navigate(-1)}>Check-in History</h2>
            </div>

            <div className="p-4 space-y-3">
                {attendanceList.length > 0 ? (
                    [...attendanceList].reverse().map((item, idx) => {
                        const formattedDate = new Date(item.date).toLocaleDateString("en-US", {
                            weekday: "short",
                            month: "short",
                            day: "numeric",
                        });

                        const isAbsent = item.status?.toLowerCase() === "absent";

                        return (
                            <div key={idx} className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-sm text-gray-500">{formattedDate}</p>
                                        <p className="text-2xl font-bold text-gray-800 mt-1">
                                            {isAbsent
                                                ?
                                                ""
                                                // <span className='bg-red-200 text-red-600 py-2 px-4 rounded-full font-semibold text-sm'>Absent</span>

                                                : item.time_in?.slice(0, 5) || "--:--"}
                                        </p>
                                    </div>
                                    {isAbsent ? (<span style={{ borderColor: "red" }} className='border border-red-600 text-red-600 py-2 px-4 rounded-full font-semibold text-sm'>Absent</span>
                                    ) : (
                                        // <CheckCircle className="w-8 h-8 text-green-500" />
                                        <span style={{ borderColor: "green" }} className='border border-red-600 text-green-600 py-2 px-4 rounded-full font-semibold text-sm'>Present</span>
                                    )}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <p className="text-gray-500 text-center py-8">No check-in records found.</p>
                )}
            </div>
        </div>
    );
};

export default CheckInHistory;
